/**
* Created by PanJiaChen on 16/11/18.
*/

const Validate = {
  /**
   * @param {string} path
   * @returns {Boolean}
   */
  isExternal (path) {
    return /^(https?:|mailto:|tel:)/.test(path)
  },

  /**
   * @param {string} str
   * @returns {Boolean}
   */
  validUsername (str) {
    const validMap = ['admin', 'editor']
    return validMap.indexOf(str.trim()) >= 0
  },

  /**
   * Validate a valid URL
   * @param {String} textval
   * @return {Boolean}
   */
  validURL (url) {
    const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return reg.test(url)
  },

  /**
   * Validate a full-lowercase string
   * @return {Boolean}
   * @param {String} str
   */
  validLowerCase (str) {
    const reg = /^[a-z]+$/
    return reg.test(str)
  },

  /**
   * Validate a full-uppercase string
   * @return {Boolean}
   * @param {String} str
   */
  validUpperCase (str) {
    const reg = /^[A-Z]+$/
    return reg.test(str)
  },

  /**
   * Check if a string contains only alphabet
   * @param {String} str
   * @param {Boolean}
   */
  validAlphabets (str) {
    const reg = /^[A-Za-z]+$/
    return reg.test(str)
  },

  /**
   * Validate an email address
   * @param {String} email
   * @return {Boolean}
   */
  validEmail (email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  }
}

export default Validate
